// theme.ts
import { createTheme, ThemeOptions } from '@mui/material/styles';

const customTheme: ThemeOptions = {
  palette: {
    primary: { main: '#006EB3' },
    secondary: { main: '#ff5722' },
    text: { primary: '#000000', secondary: '#4c4c4c' }, // Black text
    background: { paper: '#ffffff' }, // White background for the table
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h6: { fontWeight: 600 },
    body1: { color: '#000' },
    button: { textTransform: 'none' },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff', // White background for cells
        },
        head: {
          backgroundColor: '#1976d2', // Blue header
          color: '#000', // Black header text
          fontWeight: 600,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9f9f9', // Light gray background for inputs
          borderRadius: 4,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9f9f9',
          borderRadius: 4,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#006EB3', 
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          margin: '8px 0',
        },
      },
    },
    MuiPaper: {
        styleOverrides: {
            root: {
              backgroundColor: '#ffffff',
            },
          },
    }
  },
};

export const Tabletheme = createTheme(customTheme);
